import { autoinject, computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { WidgetController } from 'controls/as-widget-container';
import { ContractorTraveler, CountryExperience } from 'model/forms/travel-request';
import { KeywordsService } from 'services/keywords-service';
import { LookupsService } from 'services/lookups-service';
import { WidgetBase } from 'support/base_classes/widget-base';
import { PHONE_REGEX } from 'support/settings';

@autoinject
export class ContractorTravelerWidget extends WidgetBase<ContractorTraveler, WidgetController> {
  constructor(private keywords: KeywordsService, private lookups: LookupsService) {
    super();
  }

  bind() {
    ValidationRules
      .ensureObject<ContractorTraveler>().required()
      .ensure(model => model.firstName).displayName('First name').required()
      .ensure(model => model.lastName).displayName('Last name').required()
      .ensure(model => model.phone).displayName('Phone').required().matches(PHONE_REGEX).withMessage('Phone number in international format is required.')
      .ensure(model => model.mail).displayName('E-mail').required().email().withMessage('E-mail address in valid format is required.')
      .ensure(model => model.lineManager).displayName('Line manager / bp employee name').required()
      .ensure(model => model.organisationEntity).displayName('bp entity').required()
      .ensure(model => model.countryExperiences).satisfies((items: CountryExperience[]) => items.every(i => i.revisit != null)).withMessage('Travel experience is required.')
      .on(this.model);
  }

  @computedFrom('model.lineManager')
  get lineManagerGroupLabel() {
    return ['Line manager / bp employee name', this.model.lineManager?.mail, this.model.lineManager?.phone].filter(l => l != null);
  }

  @computedFrom('keywords.organisationEntities', 'model.organisationEntity')
  get organisationEntities() {
    return this.keywords.ensureItem(this.keywords.organisationEntities, this.model.organisationEntity);
  }

  keywordsItemMatcher = this.keywords.itemsMatch;
  usersLookupOptions = this.lookups.getUsersLookupOptions();
}
